import { render } from "./EstrategiaReventa.vue?vue&type=template&id=68b25ff2"
import script from "./EstrategiaReventa.vue?vue&type=script&lang=js"
export * from "./EstrategiaReventa.vue?vue&type=script&lang=js"

import "./EstrategiaReventa.vue?vue&type=style&index=0&id=68b25ff2&lang=scss"

import exportComponent from "/Volumes/Baguer/Develop/Quac/pagosquac-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__